module.exports = __webpack_public_path__ + "img/style_12_en.a4efd88e.jpeg";